import { IModel } from "maps-angular-components";
import { ParametroFuncao } from "./parametro-funcao";

export interface FuncaoDTO {
  nome: string;
  name: string;
  descricao: string;
  categoria: string;
  explosao: 'SIM' | 'NAO' | 'APENAS';
  parametros: ParametroFuncao[];
}
export class Funcao implements IModel {

  nome: string;
  name: string;
  descricao: string;
  categoria: string;
  explosao: 'SIM' | 'NAO' | 'APENAS';
  parametros: ParametroFuncao[];

  constructor(obj?: FuncaoDTO)
  {
    this.name = obj?.name;
    this.descricao = obj?.descricao;
    this.categoria = obj?.categoria;
    this.explosao = obj?.explosao;
    this.parametros = obj?.parametros;
  }

  getId() {
    return this.name;
  }

  getName() {
    return this.name;
  }

  equals(obj: IModel) {
    return obj.getId() == obj.getId()
  }

  toJSON() {
    return Object.assign(this);
  }
}
